// extracted by mini-css-extract-plugin
export default {"tableOfContents":"jA3UK5oLwfdBuullDdEF","titleBox":"HcGCKyaZXy4iEEV7O2uS","groups":"X3_0qHdNrV6iSDH6AUxD","group":"u2rmcqFEi21ZtSvI2NQS","items":"tVTWtb1jj6CN53guCw1U"};